import React from 'react';
import AgentProfile from '../components/AgentProfile';

const AgentDetails = () => {
  return <AgentProfile />;
};

export default AgentDetails;
